module.exports = __webpack_public_path__ + "static/media/docs-en.f1c01d6c.jpg";